// debug/useLabeledState.ts
import { useCallback, useDebugValue, useState } from "react";

export const useLabeledState = <T,>(
  initial: T,
  label: string
): [T, React.Dispatch<React.SetStateAction<T>>] => {
  const [value, setValue] = useState<T>(initial);
  useDebugValue(`${label}: ${String(value)}`);
  const set = useCallback((u: React.SetStateAction<T>) => setValue(u), []);
  return [value, set];
};


export const useStateSpy = <T,>(initial: T, label: string) => {
  const [value, _set] = useState<T>(initial);
  useDebugValue(`${label}: ${String(value)}`);
  const set = useCallback((next: React.SetStateAction<T>) => {
    const prev = value;
    const resolved = typeof next === "function" ? (next as (p: T) => T)(value) : next;
    // eslint-disable-next-line no-console
    // console.debug(`[state:${label}]`, { prev, next: resolved, stack: new Error().stack });
    _set(next);
  }, [value]);
  return [value, set] as const;
};